import React from "react";
import ServiceSpace from "../../components/dashboard/ServiceSpace";
import pricing from "../../assets/data/pricing.json";
import { adminPrices } from "../../utils/serviceFlows";
import { useSelector } from "react-redux";

function UserPlatformAdmin() {
  const { activeCompany } = useSelector((state) => state.companies);
  const prices = adminPrices(pricing.platformAdmin, activeCompany?.turnover);

  return (
    <ServiceSpace
      serviceCode="admin"
      flow="admin"
      flowPath="/platform-admin"
      title="Administration"
      lead="Vos obligations fiscales et sociales prises en charge par nos équipes."
      offer="Télédéclarations mensuelles, DSF et cotisations sociales : nous gérons vos obligations administratives dans le respect des échéances."
      price={Math.min(prices.mensuel, prices.annuel)}
      isEligible={(company) => company.country?.toUpperCase() === "CM"}
      unavailableText="L'administration d'entreprise est proposée aux entreprises situées au Cameroun."
    />
  );
}

export default UserPlatformAdmin;
